import styled, { css } from 'styled-components'

import { ctaButtonStyles } from 'src/Components/Buttons/CTAButton'

export const MainWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.unchangingColor.black};
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const LoginFieldsWrapper = styled.div`
  display: flex;
  width: 595px;
  min-width: 288px;
  max-width: 600px;
  padding: 32px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  border-radius: 16px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};
  @media screen and (max-width: 600px) {
    width: 100%;
    padding: 16px;
  }
`
interface Props {
  isConnecting?: boolean
}
export const TikTokBtnLink = styled.a<Props & { $loading?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 48px;
  padding: 0 40px;
  border-radius: 40px;
  width: auto;
  text-decoration: none;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;

  ${ctaButtonStyles}

  &:hover,
  &:visited {
    color: ${({ theme }) => theme.color.white};
  }

  ${({ isConnecting, theme }) =>
    isConnecting &&
    css`
      &,
      &:hover,
      &:visited {
        color: ${theme.color.mediumGrey};
      }
    `}
`
